
export class FetchLeaderBoard {
  static url = "https://clicker-game-9356e.firebaseio.com/Score.json/"

  static getList() {

     return fetch(this.url)
      .then(response => response.json())
      .then(response => {
        return response 
          ? Object.keys(response).map(key => ({
            ...response[key],
            id: key
          }))
          : []
      })
    
  }

  static addRecord(userData) {
    fetch(this.url, {
      method: "POST",
      body: JSON.stringify(userData),
      headers: {
        "Content-Type": "application/json"
      }
    })

  } 

}
